import styled from "styled-components";

export const AddModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 25rem;

  h1 {
    font-size: 1.5rem;
  }

  .input {
    margin-bottom: 1rem;
  }

  .divider {
    margin: 0.4rem 0;
  }
`;
